import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUser } from '../store/slices/authSlice';
import { useGetAllFamiliesQuery } from '../api/familyAPI';
import { Family } from '../../../shared/src/types/Family';
import { CardSimple } from '../components/UI/Card';
import Button from '../components/UI/Button';
import OpenTasksCounter from '../components/OpenTasksCounter';
import { InactiveFamiliesList } from '../features/families/InactiveFamiliesList';
import FamilySearch from '../components/FamilySearch';
import FamilyTable from './FamilyTable';

const MentorDashboard = () => {
  const user = useSelector(selectCurrentUser);
  const navigate = useNavigate();

  const { data: families = [], isLoading } = useGetAllFamiliesQuery();
  const [filteredFamilies, setFilteredFamilies] = useState<Family[]>(families);
  useEffect(() => {
    const filteredFamilies = families.filter(family => family.mentor_id === user?.id);
    setFilteredFamilies(filteredFamilies);
  }, [families, user]);

  return (
    <div className="p-6 min-h-screen text-right font-sans bg-background text-text-main">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold text-primary">שלום ל- {user?.name}</h1>
      </header>
      <div className="flex justify-end mb-6 gap-4">
        <div
          onClick={() => navigate(`/profile/${user?.id}`)}
          className="w-full md:w-64 h-31.5 px-4 flex flex-col items-center justify-center gap-3 rounded-2xl shadow-card bg-white text-green-700 hover:bg-green-50 transition cursor-pointer text-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0zm6 1a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span className="font-semibold text-sm">אזור אישי</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8 text-center">
    <CardSimple className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer">
          <div className="w-full h-full">
            <InactiveFamiliesList />
          </div>
        </CardSimple>

    <CardSimple className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer">
          <OpenTasksCounter />
        </CardSimple>

        <div
          onClick={() => navigate('/notification')}
          className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-primary"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
          תזכורות אישיות
        </div>

        <div
          onClick={() => navigate('/calendar')}
          className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-primary"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8 7V3m8 4V3m-9 8h10m-11 8h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          לצפייה ביומן האישי
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <div className="w-full md:w-2/3">
          <FamilySearch
            families={families}
            onSearchResultsChange={setFilteredFamilies}
          />
        </div>
        <Button
          size="md"
          variant="primary-dark"
          className="h-12 w-40"
          onClick={() => navigate('/add-family')}
        >
          יצירת משפחה חדשה
        </Button>
      </div>
      <CardSimple className="w-full p-4">
        {isLoading ? (
          <p className="text-center">טוען נתונים...</p>
        ) : filteredFamilies.length === 0 ? (
          <p className="text-center text-gray-500">לא נמצאו משפחות תואמות</p>
        ) : (
          <FamilyTable families={filteredFamilies} />
        )}
      </CardSimple>
    </div>
  );
};

export default MentorDashboard;



